import Mask, {
    getValueType,
    fixFilterValue,
    handleItemTypeChange,
} from "./Mask";
import openSearchMaskModal, { MaskWithModal } from "./Modal";
import Input, { InputWithFormsy } from "./Input";
import Recents from "./Recents";
import Advanced, { DEFAULT_ADVANCED_SEARCH_TEXT } from "./Advanced";
import Filters from "./Filters";
import SearchScope from "./SearchScope";

const SearchMask = {
    Mask,
    Modal: MaskWithModal,
    Input,
    InputWithFormsy,
    Recents,
    Advanced,
    Filters,
    SearchScope,
    openSearchMaskModal,
    getValueType,
    fixFilterValue,
    handleItemTypeChange,
    DEFAULT_ADVANCED_SEARCH_TEXT,
};

export default SearchMask;
